import type { AwsMidcIntegration } from "@p0security/integrations-aws-midc-shared/types";
import type { AwsIntegration } from "@p0security/integrations-aws-shared/types";
import { installedItems } from "@p0security/shared/install/installed";
import {
  currentInstall,
  otherInstalled,
} from "@p0security/shared/install/options";
import type { DynamicProvider } from "@p0security/shared/install/types";

import type { FrontendAws } from "../../types";

/**
 * Lists the Account Id / Account Label pair for  all of the AWS accounts
 * currently installed for the user as well as a pair for the account
 * currently being installed.
 */
export const accountReference: DynamicProvider<FrontendAws, any> = async (
  context,
  _item,
  id
) => {
  return [
    // list the account currently being installed so the user can
    //  reference it during an initial installation
    ...currentInstall<AwsIntegration>("iam-write")(context, id),
    // filter the the current account out of the "installed" list
    // to avoid double counting
    ...(await otherInstalled<AwsIntegration>("iam-write")(context)).filter(
      (item) => item.id !== id
    ),
  ];
};

/**
 * Lists installed AWS Identity Center (MIDC) accounts as selectable options
 * for the merged-idc login parent field. Reads the tenant's `aws-midc`
 * integration config, extracts all installed `identity` components, and
 * returns their account ID / label pairs.
 */
export const midcIdentityReference: DynamicProvider<FrontendAws, any> = async (
  context
) => {
  const midcConfig = context.installed["aws-midc"] as
    | AwsMidcIntegration
    | undefined;
  if (!midcConfig) return [];
  return Object.entries(installedItems("identity", midcConfig)).map(
    ([id, item]) => ({ id, label: item?.label })
  );
};
